export default __webpack_public_path__ + "static/media/openOrders.2da2622e.svg";